import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Table,
    Button,
    Input
} from "reactstrap";
import { getJokerPnL } from "../../../../helpers/apis";
import { formatDateTimeDDMMYYYY } from "../../../../helpers/dateUtils";
import { getAmountColorClass } from "../../../../Components/Common/columns/BidTranjections";

const JokerHistory = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({ summary: {}, history: [], rounds: [] });
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const fetchData = async () => {
        setLoading(true);
        try {
            const params = { startDate, endDate, page: 1, gameType: 'lt' };
            const res = await getJokerPnL(params);
            if (res && res.data) {
                setData(res.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="page-content">
            <Container fluid>
                <div className="page-title-box d-flex align-items-center justify-content-between">
                    <h4 className="mb-0">Joker History</h4>
                </div>

                <Row className="mb-3">
                    <Col md={3}>
                        <Input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            placeholder="Start Date"
                        />
                    </Col>
                    <Col md={3}>
                        <Input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            placeholder="End Date"
                        />
                    </Col>
                    <Col md={2}>
                        <Button color="primary" onClick={fetchData}>Filter</Button>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <div className="table-responsive">
                                    <Table className="table-hover table-bordered align-middle table-nowrap mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Date/Time</th>
                                                <th>Rounds (Triggered / Configured)</th>
                                                <th>Multiplier</th>
                                                <th>Total Bets</th>
                                                <th>Total Payout</th>
                                                <th>Admin P&L</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {(data.rounds || data.history || []).map((item, idx) => (
                                                <tr key={idx}>
                                                    <td>{formatDateTimeDDMMYYYY(item.startTime)}</td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span className="fw-semibold">
                                                                <span className="text-success">{item.roundsTriggered || 0}</span>
                                                                <span className="text-muted mx-1">/</span>
                                                                <span className="text-muted">{item.roundsConfigured || 0}</span>
                                                            </span>
                                                            {item.roundsConfigured > 0 && (
                                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                                    {Math.round(((item.roundsTriggered || 0) / item.roundsConfigured) * 100)}% hit rate
                                                                </small>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td><span className="badge bg-secondary">{item.multiplier}x</span></td>
                                                    <td>{item.totalBets}</td>
                                                    <td>{item.totalPayout}</td>
                                                    <td className={`fw-bold ${getAmountColorClass(item.adminProfit || 0)}`}>
                                                        {item.adminProfit || 0}
                                                    </td>
                                                </tr>
                                            ))}
                                            {(!data.rounds || data.rounds.length === 0) && (!data.history || data.history.length === 0) && (
                                                <tr><td colSpan="6" className="text-center">No Data Found</td></tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default JokerHistory;
